export const SidebarRobotIcon = ({ className = '' }: { className?: string }) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(0.917 0.917)">
      <path
        d="M16.5 15.5833C17.7962 15.5833 18.4443 15.5833 18.8467 15.18C19.25 14.7776 19.25 14.1295 19.25 12.8333C19.25 11.5372 19.25 10.8891 18.8467 10.4867C18.4452 10.0833 17.7971 10.0833 16.5 10.0833M3.66667 15.5833C2.37051 15.5833 1.72242 15.5833 1.32001 15.18C0.916674 14.7785 0.916674 14.1304 0.916674 12.8333C0.916674 11.5363 0.916674 10.8891 1.32001 10.4867C1.72151 10.0833 2.36959 10.0833 3.66667 10.0833M16.5 13.75V11.9167C16.5 9.32433 16.5 8.02725 15.6943 7.22242C14.8894 6.41667 13.5923 6.41667 11 6.41667H9.16667C6.57434 6.41667 5.27726 6.41667 4.47242 7.22242C3.66667 8.02725 3.66667 9.32433 3.66667 11.9167V13.75C3.66667 16.3423 3.66667 17.6394 4.47242 18.4443C5.27726 19.25 6.57434 19.25 9.16667 19.25H11C13.5923 19.25 14.8894 19.25 15.6943 18.4443C16.5 17.6394 16.5 16.3423 16.5 13.75Z"
        stroke="#8576F3"
        strokeWidth="1.83333"
        strokeLinejoin="round"
      />
      <path
        d="M11.4583 2.29167C11.4583 2.65634 11.3135 3.00608 11.0556 3.26394C10.7978 3.5218 10.448 3.66667 10.0833 3.66667C9.71867 3.66667 9.36893 3.5218 9.11107 3.26394C8.85321 3.00608 8.70834 2.65634 8.70834 2.29167C8.70834 1.92699 8.85321 1.57726 9.11107 1.31939C9.36893 1.06153 9.71867 0.916667 10.0833 0.916667C10.448 0.916667 10.7978 1.06153 11.0556 1.31939C11.3135 1.57726 11.4583 1.92699 11.4583 2.29167Z"
        stroke="#8576F3"
        strokeWidth="1.83333"
      />
      <path
        d="M10.0833 3.66667V6.41667M7.33334 11V11.9167M12.8333 11V11.9167"
        stroke="#8576F3"
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.25001 15.125C8.25001 15.125 8.86142 15.5833 10.0833 15.5833C11.3053 15.5833 11.9167 15.125 11.9167 15.125"
        stroke="#8576F3"
        strokeWidth="1.83333"
        strokeLinecap="round"
      />
    </g>
  </svg>
);
